import { useEffect } from "react";

const clearAppBadge = () => {
    if (navigator?.clearAppBadge) {
        navigator.clearAppBadge().catch(() => {
            console.error("Failed to clear app badge");
        });
    }
};
/**
 * PWA アイコンのバッジを、ユーザーがアプリ画面を見たタイミングで消す。
 * サービスワーカーが push 受信時に setAppBadge で「溜まり」を示し、ここでリセットして子ども向けの未読感を区切る。
 * Layout 直下で 1 回だけマウントすること（ページごとに呼ぶとリスナーと初期クリアが重複する）。
 */
export const useBadge = () => {
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                clearAppBadge();
            }
        };

        // 一度開いたあと、ホームに戻ったり別タブに行ったりして 非表示 → 再び表示になったときにクリアするためにリスナーを登録する
        document.addEventListener("visibilitychange", handleVisibilityChange);

        // visibilitychange は「状態が変わったとき」しか飛ばない。
        // アプリを起動した直後は、多くの場合すでに document.visibilityState === "visible" なので、イベントリスナーだけだとクリアが走らないことがあるため初回実行することにしています。
        clearAppBadge();

        return () => {
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
            );
        };
    }, []);
};
